import ApplicationController from './application_controller'

export default class extends ApplicationController {

  initialize(){
    document.addEventListener('stimulus-reflex:connected', () => {
      this.setFormUrl();
    })
  }

  setFormUrl(button, srcElement) {
    if (button != undefined) {
      let form = button.closest('form');
      if (button.disabled) {
        form.setAttribute('action', srcElement.dataset.formDisabled);
      } else {
        form.setAttribute('action', srcElement.dataset.formEnabled)
      }
    }
  }

  toggleButtonWithUrl(event) {
    let button = toggleButton(event);
    this.setFormUrl(button, event.srcElement);
  }

  toggleButton(event) {
    let button = event.srcElement.closest('form').querySelector('#' + event.srcElement.dataset.toggleId);
    button.toggleAttribute('disabled');
    return button;
  }
}
